import React from "react";
const ContentWrapper = ({ testid, page = '', children }) => (React.createElement("div", { "data-testid": testid, "data-page": page }, children));
export default ContentWrapper;
